import { render, staticRenderFns } from "./doughnut-chart.vue?vue&type=template&id=3d6115b0&scoped=true"
import script from "./doughnut-chart.vue?vue&type=script&lang=js"
export * from "./doughnut-chart.vue?vue&type=script&lang=js"
import style0 from "./doughnut-chart.vue?vue&type=style&index=0&id=3d6115b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6115b0",
  null
  
)

export default component.exports